export const STUDENT = "student";
export const TEACHER = "teacher";
export const ADMIN = "admin";
export const OFFICIAL_HIGHSCHOOL = "official1";
export const OFFICIAL_PRIMARYSCHOOL = "official2";
export const FOUNDATION_USER = "foundation";